import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.TABS_ROUTES),
  },
  {
    path: 'signature',
    loadComponent: () => import('./signature/signature.page').then((m) => m.SignaturePage),
  },
  {
    path: 'news',
    loadComponent: () => import('./news/news.page').then((m) => m.NewsPage),
  },
  {
    path: 'tab5',
    loadComponent: () => import('./tab5/tab5.page').then((m) => m.Tab5Page),
  },
  {
    path: 'contract',
    loadComponent: () => import('./contract/contract.page').then((m) => m.ContractPage),
  },
  {
    path: 'order',
    loadComponent: () => import('./order/order.page').then((m) => m.OrderPage),
    children: [
      {
        path: 'pdf',
        loadComponent: () => import('./pdf-view/pdf-view.page').then((m) => m.PdfViewPage),
      },
    ],
  },
  {
    path: 'order-review/:id',
    loadComponent: () => import('./order-review/order-review.page').then((m) => m.OrderReviewPage),
  },
  {
    path: 'map-view',
    loadComponent: () => import('./map-view/map-view.page').then((m) => m.MapViewPage),
  },
  {
    path: 'pdf-view',
    loadComponent: () => import('./pdf-view/pdf-view.page').then((m) => m.PdfViewPage),
  },
  {
    path: 'lead',
    loadComponent: () => import('./lead/lead.page').then((m) => m.LeadPage),
  },
  {
    path: 'calendar',
    loadComponent: () => import('./calendar/calendar.page').then((m) => m.CalendarPage),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
